export class AnswerManager {
  constructor({ answerRepo, answerHandler, messenger, formRepo }) {
    this.answerRepo = answerRepo;
    this.answerHandler = answerHandler;
    this.messenger = messenger;
    this.awaitTenSeconds = false;
    this.apiLock = false;
    this.messenger.addListener('syncAnswers', (e) => this.sendAnswersToApi(e));
    this.messenger.addListener('syncAllAnswers', () => this.syncAllAnswers());
    this.formRepo = formRepo;
  }

  async saveAnswerToRepo({ value, formId, path, questionId, questionType }) {
    await this.answerRepo.save({
      value,
      formId,
      path,
      status: 0,
      questionId,
      questionType,
    });
    this.messenger.sendMessage('syncAnswers', formId);
  }

  getAnswersWaiting(formId) {
    return this.answerRepo.getAnswers({ formId, status: 0 });
  }

  async sendAnswersToApi(formId) {
    if (this.apiLock) {
      console.log('api is already in use.');
      return;
    }
    this.apiLock = true;
    const answers = await this.getAnswersWaiting(Number(formId));
    if (answers.length === 0) {
      this.apiLock = false;
      return;
    }
    const answerIds = answers.map((a) => a.id);
    try {
      const { updatedAt } = await this.answerHandler.sendAnswers(formId, answers);
      if (updatedAt) await this.answerRepo.setAnswersStatus(answerIds, 1);
      await this.formRepo.saveValue(formId, 'updatedAt', updatedAt);
      await this.answerRepo.deleteList(answerIds);
    } catch (e) {
      await this.answerRepo.setAnswersStatus(answerIds, 0);
      console.log('error ', e.message);
    }
    this.apiLock = false;
  }

  async syncIfNumberAnswersOrNumberSeconds(formId) {
    if ((await this.getAnswersWaiting(formId)).length >= 25) {
      this.awaitTenSeconds = false;
      await this.sendAnswersToApi(formId);
      return;
    }
    if (this.awaitTenSeconds) return;
    this.awaitTenSeconds = true;
    await new Promise((r) => setTimeout(r, 5000));
    if (!this.awaitTenSeconds) return;
    this.awaitTenSeconds = false;
    await this.sendAnswersToApi(formId);
  }

  async count(formId) {
    return this.answerRepo.count(formId);
  }

  getAllFormIds() {
    return this.answerRepo.allFormIds();
  }

  async syncAllAnswers() {
    const formIds = await this.getAllFormIds();
    if (formIds === []) return;
    await Promise.all(formIds.map((id) => this.sendAnswersToApi(id)));
  }

  async sendAllAnswers() {
    const formIds = await this.getAllFormIds();
    try {
      await Promise.all(formIds.map((formId) => this.sendAnswersToApi(formId)));
    } catch (e) {
      throw new Error('answer_upload_failed');
    }
  }

  async deleteFormAnswers(formId) {
    await this.answerRepo.deleteFormAnswers(formId);
  }
}
